// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1-gPp","left":"InfoRow_left__2zRLt"};